import {first, mergeMap} from 'rxjs/operators';
import { of } from 'rxjs';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class SubscribeGuard implements CanActivate {

    constructor(private router:Router, private userService: UserService) {}

    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => this.userService.isLoggedIn()
        .pipe(
            mergeMap(status => {
                if (status.user) {
                    return of(true);
                } else {
                    return this.userService.canActivate(null, state.root.queryParams.invitationCode).pipe(first(),mergeMap(results => {
                        if (results.canActivate) {
                            this.router.navigate(['/register'], {queryParams: _.assign({originator: state.url}, state.root.queryParams)});
                        } else {
                            this.router.navigate(['/login'], {queryParams: _.assign({originator: state.url}, state.root.queryParams)});                        
                        }
                        return of(false);
                    }),)
                }
            })
        )
}